import reservationAPI from '@/services/API/reservation'
import customerAPI from '@/services/API/customer'
import inventoryAPI from '@/services/API/inventory'

function getCustomer(customerId) {
  return customerAPI.getCustomer(parseInt(customerId))

}

const fetchReservations = function({commit, state}){
  commit('SET_LOADING_RESERVATIONS', true);
  reservationAPI.fetchReservations({ paging:'no'})
    .then(reservations=>{
      commit('SET_RESERVATIONS', reservations);
      commit('SET_LOADING_RESERVATIONS', false);
    })
}

const fetchCustomerReservations = function({ commit, state}, customerId) {
  commit('SET_LOADING_CUSTOMER_RESERVATIONS', true);
  reservationAPI.fetchReservations({customerId, paging:'no'})
    .then(customerReservations=>{
      commit('SET_CUSTOMER_RESERVATIONS', customerReservations);
      commit('SET_LOADING_CUSTOMER_RESERVATIONS', false);
    })
};


// const fetchCustomer = function({ commit , state, dispatch}, customerId) {
//   commit('SET_LOADING_CUSTOMERS', true);
//   return getCustomer(customerId)
//     .then(customer=>{
//       commit('SET_RESERVATION_TO_CREATE_CUSTOMER',{customer})
//       return dispatch('setSelectedContacts',[]);
//     })
//
//
// };

// const fetchCustomers = function({ commit , state}, customerId) {
//   commit('SET_LOADING_CUSTOMERS', true);
//   // return customerAPI.fetchSearchedCustomers({paging:'no', customerId:parseInt(customerId)})
//   return customerAPI.fetchSearchedCustomers({paging:'no',customerId:parseInt(customerId)})
//     .then(customers=>{
//       commit("SET_CUSTOMERS", customers);
//       commit('SET_LOADING_CUSTOMERS', false);
//       return customers;
//     })
//
// };
// const fetchSearchedCustomers = function({ commit , state}, query) {
//   commit('SET_LOADING_CUSTOMERS', true);
//   return customerAPI.fetchSearchedCustomers({paging:'no', searchTerms:query, active:true})
//     .then(customers=>{
//       commit("SET_CUSTOMERS", customers);
//       commit('SET_LOADING_CUSTOMERS', false);
//       return customers;
//     })
//
// };

// const initReservationCreator = function({commit, state, dispatch}, {customerId, edit, product}){
//
//   if(product!=null){
//     dispatch('addDetailLine',product);
//   }
//
//   if(edit==null){
//     if(customerId!=null){
//       dispatch('fetchCustomer', parseInt(customerId))
//       dispatch('fetchCustomers', parseInt(customerId));
//     }
//     let loggedUser = JSON.parse(localStorage.user);
//     let loggedUserRepRole = _.find(loggedUser.roles, role=>{return role.role_name==="Rep"})
//     if(loggedUserRepRole){
//       dispatch('setNewReservationSalesRepId',{salesRepId : JSON.parse(localStorage.user).id});
//     }
//
//   }else{
//     return getCustomer(edit.customer.id)
//       .then((customer) => {
//         commit('RESERVATION_SET_CUSTOMER', customer);
//         commit('SET_CUSTOMERS', [customer]);
//         commit('CLONE_SELECTED_RESERVATION_FOR_EDITING',edit)
//       })
//   }
//
//
// }

// const addDetailLine = function ({commit, state, dispatch}, product){
//
//   commit('SET_DETAIL_ITEMS_LOADING', true);
//   //On chercher si ou avons deja mis ce produit dans notre réservation
//   let lineFoundWithProductID = _.find(state.reservation.details, detail=>{
//     return detail.product.id==product.product.id;
//   })
//   //Si nous n'avons pas trouvé le produit alors nous pouvons continuer
//   if(lineFoundWithProductID==null){
//
//     let newLine = {};
//
//     if(product.id){
//       newLine.product = _.cloneDeep(product);
//       newLine.product.quantity = _.cloneDeep(product.quantities[0]);
//     }else{
//       newLine.product = _.cloneDeep(product.product);
//       let quantity = _.cloneDeep(product);
//       quantity.product = null;
//       delete quantity.product;
//       newLine.product.quantity = quantity;
//     }
//
//     newLine.qty = newLine.product.uvc;
//     newLine.type = "PRODUCT_AVAILABLE";
//     if (_.get(product, 'in_stock') == 0 && _.get(product, 'pending') > 0) {
//       newLine.type = 'PRODUCT_TO_COME';
//     } else if (_.get(product, 'in_stock') == 0 && _.get(product, 'pending') == 0) {
//       newLine.type = 'INTENT';
//     }
//     newLine.delayed = product.in_stock === 0 && product.pending > 0;
//     newLine.intent = product.in_stock === 0 && product.pending === 0;
//     newLine.comment = null;
//     commit('ADD_DETAIL_LINE',newLine)
//     dispatch('validateDetailLines');
//
//     if(product.in_stock>=1){
//       return Promise.resolve("AVAILABLE");
//     }else if(product.pending>=1){
//       return Promise.resolve("PENDING_ONLY");
//     }else{
//       return Promise.resolve("NOT_AVAILABLE");
//     }
//
//   }else{
//     return Promise.resolve("DUPLICATE_ITEM");
//   }
// }

// const validateDetailLines = function ({commit, state}){
//   reservationAPI.validate(state.reservation)
//     .then(validatedReservationDetails=>{
//         //Mettre a jour tous les detail line de la réservation avec la réponse du backend
//         commit('UDPATE_DETAIL_LINES', validatedReservationDetails);
//     })
// }

// const setDetailQty = function({commit, state, dispatch}, {index, qty}){
//   commit("SET_DETAIL_QTY", {index,qty})
//   dispatch('validateDetailLines');
// }

// const setComment = function({commit}, {index, comment}){
//   commit("SET_COMMENT", {index, comment});
// }

// const removeItemLine = function({commit, state}, index){
//   commit("REMOVE_DETAIL_ITEM_LINE", index);
// }

// const setNewReservationSalesRepId = function({commit,state}, {salesRepId}){
//   commit("SET_NEW_RESERVATION_SALES_REP", salesRepId);
// }

// const reset = function({ commit }) {
//   commit('RESET_STATE');
// };

// const setDelayed = function({ commit, dispatch }, {index, delayed}){
//   commit('SET_DELAYED', {index, delayed});
//   dispatch('validateDetailLines');
// }


const postNewReservation = function({commit, state, dispatch}){
  commit('SET_EDITOR_LOADING',true);
  let reservationsToCreate = [];
  _.forEach(state.reservation.details, item=>{
    let detailLine = {};
    detailLine.product = item.product;
    detailLine.qty = item.qty;
    detailLine.customerId = state.reservation.customer.id;
    detailLine.salesRepId = state.reservation.salesRepId;
    detailLine.delayed = item.type === 'PRODUCT_TO_COME';
    detailLine.intent = item.type === 'INTENT';
    detailLine.comment = item.comment;
    detailLine.selectedContacts = state.reservation.selectedContacts;
    reservationsToCreate.push(detailLine);
  })
  return reservationAPI.postReservation(reservationsToCreate)
    .then(()=>{
      commit('SET_EDITOR_LOADING',false);
      dispatch('stockItems/invalidateStockItems',null,{root:true});
    }).catch(err=>{
      commit('SET_EDITOR_LOADING',false);
    })
}

const putReservation = function({commit, state}){

  let reservationsToUpdate = {};
  reservationsToUpdate.product = state.reservation.details[0].product;
  reservationsToUpdate.comment = state.reservation.details[0].comment;
  reservationsToUpdate.qty = state.reservation.details[0].qty;
  reservationsToUpdate.customerId = state.reservation.customer.id;
  reservationsToUpdate.salesRepId = state.reservation.salesRepId;
  reservationsToUpdate.id = state.reservation.id;
  reservationsToUpdate.selectedContacts = state.reservation.selectedContacts;

  return reservationAPI.putReservation(reservationsToUpdate);
}

// const setCustomer = function({commit, state, dispatch}, customer){
//   if (state.reservation.customer != null && state.reservation.customer.id != customer.id) {
//     commit('SET_SELECTED_CONTACTS', []);
//   }
//   commit('RESERVATION_SET_CUSTOMER', customer);
//   if (customer != null && customer.rep != null) {
//     commit('SET_NEW_RESERVATION_SALES_REP', customer.rep.id);
//   }
//
// }

const validateReservation = function({state}){
  let errorCode = null;
  let valid  = true;
  _.forEach(state.reservation.details, detail=>{
    if(detail.invalid){
      valid = false;
    }
    if(detail.errors){
      errorCode = detail.errors.jse_info.errorCode;
      valid = false;
    }

    //Custom validation
    if(errorCode==="BOIRES_RESERVATION_120_DAYS"){
      if(detail.comment==null || detail.comment===""){
        valid = false;
      }else{
        valid = true;
      }

    }

  })
  return valid;
}

// const setSelectedContacts = function({commit},contacts){
//   return commit('SET_SELECTED_CONTACTS', contacts);
// }

// const setReservationType = function({commit}, {index, type}) {
//   // console.log('setReservationType : ', { index, type });
//   commit('SET_RESERVATION_TYPE', {index, type});
// }

export default {
  fetchCustomerReservations,
  // fetchCustomer,
  // fetchCustomers,
  // initReservationCreator,
  // addDetailLine,
  // setDetailQty,
  // removeItemLine,
  // setNewReservationSalesRepId,
  // reset,
  postNewReservation,
  putReservation,
  fetchReservations,
  // fetchSearchedCustomers,
  // setCustomer,
  // setDelayed,
  // validateDetailLines,
  // setComment,
  validateReservation,
  // setSelectedContacts,
  // setReservationType
};
